import Chip from "@mui/material/Chip";
import { NoteStatus, NoteType } from "../../types/credit-debit-note.type";
import {
  NOTE_STATUS_COLOR,
  NOTE_STATUS_LABEL,
  NOTE_TYPE_COLOR,
  NOTE_TYPE_LABEL,
} from "./constants";

export function NoteTypeChip({ noteType }: Readonly<{ noteType: NoteType }>) {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={NOTE_TYPE_LABEL[noteType]}
      color={NOTE_TYPE_COLOR[noteType]}
    />
  );
}

export function NoteStatusChip({ status }: Readonly<{ status: NoteStatus }>) {
  return (
    <Chip size="small" label={NOTE_STATUS_LABEL[status]} color={NOTE_STATUS_COLOR[status]} />
  );
}
